import { SET_TOKENS, LOG_OUT, SET_CURRENT_USER } from "actions";

export const setAuthTokens = (tokens) => ({ type: SET_TOKENS, tokens });
export const logOut = () => ({ type: LOG_OUT });
export const setCurrentUser = (user) => ({ type: SET_CURRENT_USER, user });
